import React from 'react';

export default function PlayIcon() {
  return (
    <div className="pointer-events-none absolute left-[10px] top-[10px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 38 38"
        className="h-6 w-6 object-contain lg:h-8 lg:w-8"
      >
        <defs>
          <filter id="dropShadow" x="-50%" y="-50%" width="200%" height="200%">
            <feOffset result="offOut" in="SourceAlpha" dx="2" dy="1" />
            <feGaussianBlur result="blurOut" in="offOut" stdDeviation="3" />
            <feColorMatrix in="blurOut" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" />
            <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
          </filter>
        </defs>
        <circle cx="19" cy="19" r="9.064" fill="#121214" filter="url(#dropShadow)" />
        <path
          d="M20 2.969c-7.53 0-13.654 6.125-13.654 13.654 0 7.528 6.124 13.653 13.654 13.653 7.529 0 13.654-6.125 13.654-13.653C33.654 9.093 27.529 2.97 20 2.97ZM25.428 17.1l-7.965 5.12a.567.567 0 0 1-.58.021.568.568 0 0 1-.297-.5v-10.24a.568.568 0 0 1 .877-.478l7.965 5.12a.57.57 0 0 1 0 .957Z"
          fill="#fff"
        />
      </svg>
    </div>
  );
}
